"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendErrorToNoibu = void 0;
/**
 * Sends the collected error to Noibu for error collection.
 * Makes sure that the Noibu script has loaded
 * @param  {Error} err
 */
function sendErrorToNoibu(err) {
    if (window.NOIBUJS && window.NOIBUJS.addJsSdkError) {
        window.NOIBUJS.addJsSdkError(err, 'VueError');
    }
}
exports.sendErrorToNoibu = sendErrorToNoibu;
